import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

// Package
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

// Util
import { messageKeyPrefix } from "../../../utils/message.util";

// Slice
import { fetchRecentLogins } from "../../../stores/slice/user";
import { uiActions } from "../../../stores/slice/ui";

// UI component
import MessageBox from "../../../components/MessageBox";
import InlineTitle from "../../../components/InlineTitle";
import PaginationContainer from "../../../components/PaginationContainer";

// Const
import Nuclias from "../../../const/nuclias";
import { timeFormat } from "../../../const/nuclias/dateFormat";
import { LoginMessages } from "./const";

// Sub compoment
import RecentLoginsTable from "./RecentLoginsTable";

// defaultMessages
const defaultMessages = {
  danger: null,
  generateModalDanger: null,
};

// Table field config
const columns = [
  {
    label: "5b8c99dad1",
    accessor: "publicIp",
    sortable: true,
  },
  {
    label: "5f4b6f1ca7",
    accessor: "location",
    sortable: true,
  },
  {
    label: "f7a17ad20c",
    accessor: "dateTime",
    sortable: true,
  },
];

const RecentLogin = () => {
  const { t } = useTranslation();
  const recentLogins = useSelector((state) => state.user.recentLogins);
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(Nuclias.tableSetting.pageLimit);
  const [messages, setMessages] = useState({ ...defaultMessages });

  const formatLoginRecordsTargetData = () => {
    let loginInfos = [];
    recentLogins.forEach((loginInfo, index) => {
      let tmpLoginInfo = {
        id: null,
        publicIp: null,
        location: null,
        dateTime: null,
      };
      if (
        loginInfo.newValue &&
        [
          LoginMessages.LOGIN_SUCCESSFUL,
          LoginMessages.SSO_LOGIN_SUCCESSFUL,
        ].includes(loginInfo.changedObjectName)
      ) {
        tmpLoginInfo.id = loginInfo.id;
        tmpLoginInfo.publicIp = loginInfo.newValue.publicIp;
        tmpLoginInfo.location =
          loginInfo.newValue.city + " / " + loginInfo.newValue.country;
        tmpLoginInfo.dateTime = dayjs(loginInfo.createdAt).format(
          timeFormat.dateAndTimeToMinute
        );
        loginInfos.push(tmpLoginInfo);
      }
    });
    return loginInfos;
  };

  const initFetch = useCallback(async () => {
    try {
      dispatch(uiActions.showSpinner());
      await dispatch(fetchRecentLogins()).unwrap();
    } catch (error) {
      setMessages({
        ...messages,
        danger: error.code,
      });
    } finally {
      dispatch(uiActions.hideSpinner());
    }
  }, [dispatch]);

  useEffect(() => {
    initFetch();
    return () => {};
  }, [initFetch]);

  return (
    <div className="layout-container layout-container--column layout-container--fluid">
      <MessageBox
        show={!!messages.danger}
        label={t(`${messageKeyPrefix.e.s}${messages.danger}`)}
        variant="danger"
        onClose={() => setMessages({ ...messages, danger: null })}
      />
      {recentLogins && <InlineTitle label={t("5884abfc76")} />}
      {recentLogins && (
        <RecentLoginsTable
          data={formatLoginRecordsTargetData()}
          columns={columns}
          currentPage={currentPage}
          pageLimit={pageLimit}
        />
      )}
      {recentLogins && (
        <PaginationContainer
          previousLabel={"dd1f775e44"}
          nextLabel={"10ac3d0425"}
          total={recentLogins ? recentLogins.length : 0}
          onPageChange={(currentPageNum) => setCurrentPage(currentPageNum)}
          onEntryLimitChange={(currentPageNum) => {
            setPageLimit(currentPageNum);
            setCurrentPage(1);
          }}
          pageLimit={pageLimit}
        />
      )}
    </div>
  );
};

export default RecentLogin;
